// 暂停所有视频播放
function pauseVideo() {
  let child_length = $(
    '.gift_guide5_wall_2025 .image_list_gift_gude_2025 .image_item_gift_gude_2025'
  ).length
  for (let i = 1; i <= child_length; i++) {
    let videoEl = document.getElementById(`video-${i}`)
    try {
      videoEl.pause()
    } catch (error) {}
  }
}
var mySwiper = new Swiper('.swiper_product_gift_guide5_2025', {
  slidesPerView: 1,
  spaceBetween: 20,
  effect: 'fade',
  autoHeight: true,
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.button_next',
    prevEl: '.button_prev',
  },

  // 防止一开始弹窗为none时swiper切换无效
  observer: true,
  observeParents: true,
  on: {
    slideChangeTransitionEnd: function () {
      pauseVideo()
      try {
        console.log(this.activeIndex, '===')
        document.getElementById(`video-${this.activeIndex + 1}`).play()
      } catch (error) {}
    },
  },
})

// 产品点击事件
let scrollTop = ''
$(
  '.gift_guide5_wall_2025 .image_list_gift_gude_2025 .image_item_gift_gude_2025'
).click(function () {
  let index = $(
    '.gift_guide5_wall_2025 .image_list_gift_gude_2025 .image_item_gift_gude_2025'
  ).index(this)
  mySwiper.slideTo(index, 0)
  $('.product_dialog_gift_gude_2025').css('display', 'block')
  scrollTop = $(window).scrollTop()
  $('body').css('top', 0 - scrollTop)
  // $('body').addClass('noscroll');
  document.getElementById(`video-${index + 1}`).play()
})

// 关闭弹窗
$('.product_dialog_gift_gude_2025 .close_dialog').click(function () {
  pauseVideo()
  $('.product_dialog_gift_gude_2025').css('display', 'none')
  // $('body').removeClass('noscroll');
  $(window).scrollTop(scrollTop)
})

// show_more buttom
let number = $('.gift_guide5_wall_2025 .showcase_image_wall .show_more').data(
  'only'
)
$('.gift_guide5_wall_2025 .showcase_image_wall .show_more').click(function () {
  number += number
  console.log(number)
  for (let i = 0; i < number; i++) {
    $(
      '.gift_guide5_wall_2025 .image_list_gift_gude_2025 .image_item_gift_gude_2025'
    )
      .eq(i)
      .show()
    $('.gift_guide5_wall_2025 .swiper-wrapper .product_item')
      .eq(i)
      .css('display', 'flex')
  }
  mySwiper.update(true)
  if (
    $(
      '.gift_guide5_wall_2025 .image_list_gift_gude_2025 .image_item_gift_gude_2025'
    )
      .last()
      .css('display') == 'block'
  ) {
    $('.gift_guide5_wall_2025 .showcase_image_wall .show_more').hide()
  }
})

var showcase_swiper = new Swiper(
  '.gift_guide5_wall_2025 .image_list_gift_gude_2025 .swiper_content',
  {
    slidesPerView: 4,
    spaceBetween: 24,
    navigation: {
      nextEl:
        '.gift_guide5_wall_2025 .image_list_gift_gude_2025 .swiper-button-next',
      prevEl:
        '.gift_guide5_wall_2025 .image_list_gift_gude_2025 .swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination-gift-gude-2025',
    },
    breakpoints: {
      360: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  }
)
